var Step3Manager = function () {

    "use strict";

    var self = this;

    this.initialize = function () {
        this.eventDelegation();
        this.toggleCountryPickerVisibility('[name="id-type"]');

        if (typeof navigator == 'undefined' || !navigator.userAgent || !navigator.maxTouchPoints) return;
        const isAppleDevice = navigator.userAgent.includes('Macintosh');
        const isTouchScreen = navigator.maxTouchPoints >= 1;
        const form = document.querySelector('form#bookingForm');
        if (!form) return;
        const isIpadInput = document.createElement('input');
        isIpadInput.type = 'hidden';
        isIpadInput.name = 'isIpad';
        isIpadInput.value = isAppleDevice && isTouchScreen;
        form.appendChild(isIpadInput);
    };

    this.eventDelegation = function () {
        $('[name="id-type"]').change(function () {
            self.toggleCountryPickerVisibility(this);
        });
        $('[name="dni_nif"]').change(function () {
            self.toggleCountryPickerVisibility(this);
        });
    };

    this.toggleCountryPickerVisibility = function (field) {
        var passport = 'Passport';
        var container = $(field).data('container-referrer');
        if ($(field).val() == passport) {
            $('[data-container="' + container +'"]').show();
        } else {
            $('[data-container="' + container + '"]').hide();
        }
    };

    this.initialize();
};


export default Step3Manager;
